import styled from 'styled-components';

export const DocumentWrapper = styled.div`
  height: 900px;
`;

export const ToolbarWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const ElementWrapper = styled.div`
  display: flex;
  align-items: center;
`;
